/**
 * Nominal Header Bar – front-end interactivity.
 *
 * Handles mobile menu toggle and scroll-aware shadow.
 */

( function () {
	const header = document.querySelector( '.nominal-header' );
	if ( ! header ) return;

	/* ── Mobile toggle ─────────────────────────────────────────── */
	const toggle = header.querySelector( '[data-header-toggle]' );
	if ( toggle ) {
		toggle.addEventListener( 'click', () => {
			const expanded = toggle.getAttribute( 'aria-expanded' ) === 'true';
			toggle.setAttribute( 'aria-expanded', String( ! expanded ) );
			header.classList.toggle( 'is-open', ! expanded );
		} );
	}

	/* ── Scroll shadow ─────────────────────────────────────────── */
	let ticking = false;

	function onScroll() {
		if ( ! ticking ) {
			window.requestAnimationFrame( () => {
				header.classList.toggle( 'is-scrolled', window.scrollY > 8 );
				ticking = false;
			} );
			ticking = true;
		}
	}

	window.addEventListener( 'scroll', onScroll, { passive: true } );
	onScroll();
} )();
